import React from "react";
import BotSelectorBox from "./Shared/BotSelectorBox";
import { useSelector } from "react-redux";
//shared components
import CountriesTable from "components/BotActivity/BotActivityPanels/BlockedSessionsGeographyPanel/BlockedSessionsGeographyGraphs/CountriesTable";

const ReportingCountriesTable = (props) => {
const {botCountriesToShow, setBotCountriesToShow, setLoading} = props;  


    //Initial Render UseEffect
    React.useEffect(() => {
        //Get all bot countries from the blockedSessionsGeographyData
        if (botCountriesToShow.size === 0) {
            const countries = new Map(
                Object.entries(props.blockedSessionsGeographyData?.blockedSessionGeography?.data?.bot ?? {}).map(
                    ([key, value]) => [key, true]
                )
            );
            setBotCountriesToShow(countries);
        }
    }, []);


    // Filter the countries data based on botCountriesToShow
    const allCountriesData = props.blockedSessionsGeographyData?.blockedSessionGeography.data;
    let filteredData = { ...allCountriesData };

        if (allCountriesData?.bot && botCountriesToShow && botCountriesToShow.size > 0) {
        filteredData.bot = Object.fromEntries(
            Object.entries(allCountriesData.bot).filter(([country]) => botCountriesToShow.get(country))
        );
    }

    return (
        <>
            <h3 className="title">Blocked Bots By Country</h3>
            <CountriesTable data={filteredData} />
        </>
    );
};

export default ReportingCountriesTable;